import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import {
  NavigateFunction,
  Outlet,
  useNavigate,
  useParams,
} from 'react-router-dom'

import { getGroup } from '@disco/state-management/selectors/groups'

import type { Group } from 'types/group'

import type { RootState } from 'store/configureStore'

const mapStateToProps = (
  state: RootState,
  { params: { channelId } }: { params: { channelId: string } },
) => ({
  group: getGroup(state, {
    groupId: parseInt(channelId),
  }),
})

class ChannelChecker extends React.Component<
  {
    group: Group | null | undefined
    // children: React.ReactNode
    navigate: NavigateFunction
    params: { channelId: string }
  },
  null
> {
  componentDidMount() {
    if (!this.props.group) this.props.navigate('/')
  }

  render() {
    if (!this.props.group) return null
    return <Outlet />
  }
}

const mapDispatchToProps = {}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

const ConnectedChannelChecker = connector(ChannelChecker)

// HOC to provide navigate function to class component
const ChannelCheckerWithNavigate = (props: Partial<PropsFromRedux>) => {
  const navigate = useNavigate()
  const params = useParams<{ channelId: string }>()
  if (!params.channelId) return null
  return (
    <ConnectedChannelChecker
      {...props}
      navigate={navigate}
      params={params as { channelId: string }}
    />
  )
}

export default ChannelCheckerWithNavigate
